import { useMemo } from "react";
import { Box } from "@mui/material";
import { ParagraphText, UBRadioBox } from "../../../../Libraries";
import TabAutoComplete from "../../../../Libraries/TabAutoComplete";
import { PaymentMethodToggle } from "../../../common";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { updatedPaymentMethods } from "../../../../constants";
import { CoinIcon } from "../../../../assets/icons/icon";
import formStyles from "../../SaleExpense/SaleExpenseForm/styles.module.css";
import styles from "../BillPayments/BillPayments.module.css";

const VouchersReviewSection = ({
  I18n,
  state,
  setState,
  categoryList = [],
  balance,
  balanceLoading = false,
  earnPoints = 0,
}) => {
  const amount = state.voucherObj?.discounted_price ?? state.voucherObj?.price ?? 0;
  const voucherName = state.voucherObj?.voucher_type || "";
  const icon = state.voucherObj?.icon?.[0] || state.voucherObj?.icon || "";
  const isInsufficient = !balanceLoading && balance < amount;

  const categoryOptions = useMemo(
    () =>
      (categoryList || []).map((item) => ({
        id: item.id,
        labelText: item.label || item.name,
        label: (
          <ParagraphText className={formStyles.contactLabel}>
            <span className="newFontColor">{item.label || item.name}</span>
          </ParagraphText>
        ),
        value: item.label || item.name,
      })),
    [categoryList],
  );

  return (
    <Box className={styles.reviewWrapper}>
      <Box className={styles.amountCard}>
        <ParagraphText className={`fontSize14 newLightColor ${styles.amountLabel}`}>
          {I18n.amount}
        </ParagraphText>
        <Box className={styles.amountRow}>
          <ParagraphText className={`fontSize24 fontWeight600 newFontColor ${styles.amountValue}`}>
            Rs. {formatNum(amount)}
          </ParagraphText>
        </Box>

        <Box className={styles.billDetailRow}>
          {icon && (
            <Box className={styles.billDetailIconWrapper}>
              <img src={icon} alt="" className={styles.billDetailIcon} />
            </Box>
          )}
          <Box className={styles.billDetailText}>
            <ParagraphText className="fontSize14 newFontColor">
              {state.customerName}
            </ParagraphText>
            {state.customerPhone ? (
              <ParagraphText className="fontSize14 newLightColor">
                {state.customerPhone}
              </ParagraphText>
            ) : null}
          </Box>
          {voucherName ? (
            <ParagraphText className={`fontSize14 newLightColor ${styles.dueDate}`}>
              {voucherName}
            </ParagraphText>
          ) : null}
        </Box>

        {earnPoints ? (
          <Box className={styles.earnPointsRow}>
            <CoinIcon />
            <ParagraphText className="fontSize14 newFontColor">
              {I18n.you_will_earn}{" "}
              {earnPoints} {I18n.points}
            </ParagraphText>
          </Box>
        ) : null}

        {isInsufficient && (
          <ParagraphText className={`fontSize12 ${styles.insufficientText}`}>
            {I18n.insufficient_balance_please_try_different_amount}
          </ParagraphText>
        )}
      </Box>

      <Box className={styles.reviewFields}>
        <Box className={`${formStyles.tabAutoCompleteBox} tabAutoCompleteBox`}>
          <TabAutoComplete
            id="voucher_review_category"
            list={categoryOptions}
            label={I18n.select_category}
            handleSelect={(item) => {
              setState((e) => ({
                ...e,
                expenseCategory: item?.labelText || item?.value || "",
                expenseCategoryId: item?.id || "",
              }));
            }}
            value={state.expenseCategory || ""}
            placeholder={I18n.select_category}
            handleStartLogEvent={() => {}}
            manuallyFocusInput={false}
            handleManuallyInput={() => {}}
          />
        </Box>

        <Box className={`paymentStatusBoxWrapper ${formStyles.paymentStatusBoxWrapper}`}>
          <Box className={formStyles.paymentStatusBox}>
            <Box className={formStyles.paymentStatusBoxLeft}>
              <UBRadioBox
                label={"Paid"}
                displayLabel={I18n.paid}
                onChange={(value) => {
                  setState((e) => {
                    const next = { ...e, paymentStatus: value };
                    if (!e.paymentMode) {
                      next.paymentMode =
                        updatedPaymentMethods.find((m) => m.name === "bank")
                          ?.display_name || "Bank";
                    }
                    return next;
                  });
                }}
                value={state.paymentStatus}
              />
              <UBRadioBox
                label={"Unpaid"}
                displayLabel={I18n.unpaid}
                onChange={(value) => {
                  setState((e) => ({ ...e, paymentStatus: value }));
                }}
                value={state.paymentStatus}
              />
            </Box>
            <Box className={formStyles.paymentStatusBoxRight}>
              <PaymentMethodToggle
                visible={
                  (state.paymentStatus || "").toLocaleLowerCase() === "paid"
                }
                value={(state.paymentMode || "").toLowerCase() || null}
                onChange={(method) => {
                  setState((e) => ({
                    ...e,
                    paymentMode: method?.display_name || method?.name || "Bank",
                  }));
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default VouchersReviewSection;
